// src/Components/TrustedCompanies.jsx
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { trustedCompanies } from "../Constants";

const TrustedCompanies = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const repeatedCompanies = trustedCompanies.concat(trustedCompanies, trustedCompanies);

  return (
    <section
      className="bg-[#0d1117] py-16 sm:py-20 relative overflow-hidden border-t border-white/5"
      id="clientes"
    >
      {/* Título */}
      <div
        className="text-center max-w-4xl mx-auto mb-12 sm:mb-16 px-4 sm:px-10 lg:px-20"
        data-aos="fade-down"
      >
        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
          Empresas que{" "}
          <span className="bg-gradient-to-r from-blue-600 to-blue-400 text-transparent bg-clip-text">
            confían en nosotros
          </span>
        </h2>
        <p className="text-neutral-400 mt-4 text-base sm:text-lg">
          Hemos ayudado a distintos negocios a dar el salto hacia el mundo digital.
        </p>
      </div>

      {/* Carrusel */}
      <div className="relative w-full" data-aos="fade-up">
        {/* Difuminados laterales */}
        <div className="absolute top-0 left-0 w-16 sm:w-32 h-full bg-gradient-to-r from-[#0d1117] to-transparent z-20" />
        <div className="absolute top-0 right-0 w-16 sm:w-32 h-full bg-gradient-to-l from-[#0d1117] to-transparent z-20" />

        <div className="overflow-hidden">
          <div className="flex gap-4 sm:gap-6 w-max animate-marquee-companies hover:[animation-play-state:paused]">
            {repeatedCompanies.map((company, index) => (
              <div
                key={index}
                className="group flex flex-col bg-[#1c1c1c] border border-blue-500/10 rounded-2xl overflow-hidden w-40 sm:w-48 shrink-0 transition duration-300 hover:border-blue-500/30 hover:shadow-lg hover:shadow-blue-600/20"
              >
                {/* Logo */}
                <div className="h-20 sm:h-24 flex items-center justify-center px-4 py-3">
                  <img
                    src={company.logo}
                    alt={company.name}
                    className="max-h-full max-w-full object-contain grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition duration-300"
                  />
                </div>

                {/* Nombre */}
                <div className="border-t border-white/5 bg-black/20 px-3 py-2 text-center">
                  <span className="text-xs sm:text-sm font-medium text-neutral-400 group-hover:text-blue-400 transition-colors duration-300 truncate block">
                    {company.name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedCompanies;